var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBallBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 101,
    viewBox: "0 0 102 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.3912 100.884C19.4833 99.0093 -1.62345 74.8718 0.25271 47.2192C2.36339 19.3322 26.2844 -1.75885 54.1922 0.115905C81.8656 2.22501 102.972 26.1282 101.096 54.0152C99.22 81.6678 75.0645 102.759 47.3912 100.884Z",
    fill: "url(#paint0_radial_810_77610)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_810_77610",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.0586 36.0489) rotate(92.72) scale(71.0311 71.084)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00887753,
    stopColor: "#C9F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1723,
    stopColor: "#B5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377898,
    stopColor: "#A9E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582742,
    stopColor: "#78D4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800743,
    stopColor: "#00B4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088B6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallBig);
export default __webpack_public_path__ + "static/media/ballBig.d65478235f330b3b32cfa5a5a53bb59e.svg";
export { ForwardRef as ReactComponent };